<template>
<div :style="'background:url(' + require('@/assets/bg-top-right.png') +') fixed '" style="margin-top:200px">

     <v-row>
          <v-col v-if="!isLoading" lg="8" md="8" sm="12" >
               <v-row v-for="(item,index) in news" :key="index">
                    <v-col cols="12">
                         <h1  @click="goTo(item)" class="titleStyle textSizeT container">{{ localLang =='fr' ? item.title : item.titleAr }}</h1>
                    </v-col>
                    <v-col  cols="12" v-if="item.img != null">
                         <v-img aspect-ratio="2"  cover :src="'news/' + item.img | URL"></v-img>
                    </v-col>
                    <v-col cols="12">
                         <p class="textSizeP container">
                              {{ localLang == 'fr' ? item.text1.substring(0,300) : item.text1Ar.substring(0,300) }}
                         </p> 
                    </v-col>
               </v-row>
          </v-col> 
          <v-col v-else lg="8" md="8" sm="12">
               <v-skeleton-loader  ref="skeleton" type="table-heading, list-item-two-line, image, table-tfoot"></v-skeleton-loader> 
          </v-col>
           <v-col lg="4" md="4" class="hidden-sm-and-down"  >
               <v-card v-if="!isLoading" class="mx-auto" max-width="400" tile>
                    <v-list flat>
                         <v-subheader>
                              <h2 :style="'color:' + (settings[0] ? settings[0].color : '#2F839D') ">{{ $t('flashNews') }}</h2>
                         </v-subheader>
                         <v-list-item-group   color="primary">
                              <v-list-item v-for="(item, i) in news" :key="i" @click="goTo(item)">
                                   <v-list-item-icon>
                                        <h6>{{ item.created_at | moment }} </h6>
                                   </v-list-item-icon>
                                   <v-list-item-content v-text="localLang == 'fr' ? item.title : item.titleAr">
                                        <v-list-item-title></v-list-item-title>
                                   </v-list-item-content>
                              </v-list-item>
                         </v-list-item-group>
                    </v-list>
               </v-card>
               <v-skeleton-loader v-else ref="skeleton" type="article, actions"></v-skeleton-loader>
          </v-col>
     </v-row>
</div>
</template>

<script>
export default { 
     
     data: () => ({  
          
     }),

     methods: {
          goTo(data) {  
               this.$router.push({name:'detailsNews',params:{id:data.id}})
          },
          
     },
     computed: {
          
          news() {
               return this.$store.state.news
          }
     }
}
</script>

<style scoped>
.titleStyle {
     color: #163860 !important;
}

.titleStyle:hover {
     color: rgb(7, 157, 216) !important;
     cursor: pointer;
     ;
}
</style>
